import { AlertTriangle, Lock, Zap } from 'lucide-react';

export function ProblemSection() {
	return (
		<section className="py-20 px-6 lg:px-8 bg-gray-50">
			<div className="mx-auto max-w-6xl">
				<div className="text-center mb-16">
					<h2 className="text-3xl font-bold text-gray-900 sm:text-4xl">
						Lead Generation Problem in 2025
					</h2>
					<p className="mt-4 text-lg text-gray-600">
						Overused data sources lead to spam filters and poor conversion rates
					</p>
				</div>

				<div className="grid grid-cols-1 md:grid-cols-3 gap-8">
					<div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
						<div className="w-12 h-12 bg-red-100 rounded-xl flex items-center justify-center mb-6">
							<AlertTriangle className="w-6 h-6 text-red-600" />
						</div>
						<h3 className="text-xl font-semibold text-gray-900 mb-4">
							Overused Data Sources
						</h3>
						<p className="text-gray-600">
							Using the same outdated databases as thousands of other companies gets
							you marked as spam and poor response rates
						</p>
					</div>

					<div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
						<div className="w-12 h-12 bg-yellow-100 rounded-xl flex items-center justify-center mb-6">
							<Lock className="w-6 h-6 text-yellow-600" />
						</div>
						<h3 className="text-xl font-semibold text-gray-900 mb-4">
							Relevant Data Locked Away
						</h3>
						<p className="text-gray-600">
							The best lead sources are manual, hard to automate, and difficult to
							enrich with useful contact information
						</p>
					</div>

					<div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
						<div className="w-12 h-12 bg-orange-100 rounded-xl flex items-center justify-center mb-6">
							<Zap className="w-6 h-6 text-orange-600" />
						</div>
						<h3 className="text-xl font-semibold text-gray-900 mb-4">
							Integration Nightmare
						</h3>
						<p className="text-gray-600">
							Difficult to get leads from research into your existing workflow with
							Instantly, Smartlead, and other tools
						</p>
					</div>
				</div>
			</div>
		</section>
	);
}
